/**
 * Textarea — multi-line text input primitive.
 *
 * WHEN TO USE: descriptions, notes, long-form content.
 * WHAT NOT TO DO: don't use for single-line fields — use Input instead.
 */
import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export default React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ error, className = '', ...props }, ref) {
    return (
      <textarea
        ref={ref}
        className={[
          'w-full px-3 py-2.5 rounded-input bg-gray-800 border text-ui text-gray-100 leading-relaxed',
          'placeholder:text-gray-500 resize-y min-h-[80px]',
          'transition-colors duration-fast',
          'focus:outline-none focus:ring-2 focus:ring-offset-0',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error
            ? 'border-danger-500 focus:ring-danger-500/30'
            : 'border-gray-700 focus:border-brand-500 focus:ring-brand-500/20',
          className,
        ].join(' ')}
        {...props}
      />
    );
  }
);
